import { Suspense, lazy, useState, useEffect, useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useStore } from '../hooks/useStore';
import useHttp from '../hooks/useHttp';
import useProgress from '../hooks/useProgress';
import useAppData from '../hooks/useAppData';
import Hero from '../UIComponents/Hero';
import Modal from "../UIComponents/Modal";
import LoadingAnim from '../UIComponents/LoadingAnim';
import '../styles/common.css';

const TicketsIntro = lazy(() => import('../components/Booking/TicketsIntro'));
const BookTickets = lazy(() => import('../components/Booking/BookTickets'));
const Calendar = lazy(() => import('../components/Calendar'));
const PriceCard = lazy(() => import('../UIComponents/PriceCard'));
const Maintenance = lazy(() => import('../UIComponents/Maintenance'));

const Ticketing = () => {
  const [state, dispatch] = useStore();
  const { sendRequest } = useHttp();
  const { appData, step, gaClientId, gaSessionId, dateTimeConfirmed } = state;
  // const { processContent } = useAppData();
  // const { goDirect } = useProgress();
  const [tours, setTours] = useState([]);
  const [appLoaded, setAppLoaded] = useState(false);
  // const [hash, setHash] = useState(window.location.hash.replace('#', ''));

  const col = colSize(tours);

  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
    const locale = window.navigator.userLanguage || window.navigator.language;
    dispatch('SET', {
      calendarType: 'booking',
      isUS: locale === 'en-US',
      showLoader: false
    });
  }, []);

  useEffect(() => {
    setAppLoaded(true);
    if (appLoaded) {
      getGAvalues();
    }

    return () => {
      setAppLoaded(false);
    }
  }, [appLoaded]);

  const getGAvalues = () => {
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('get', 'G-XFV6SM08Y0', 'client_id', (client_id) => {
          dispatch('SET', {
            gaClientId: client_id,
          });
        });
        window.gtag('get', 'G-XFV6SM08Y0', 'session_id', (session_id) => {
          dispatch('SET', {
            gaSessionId: session_id,
          });
        });
      }
    }, 300);
    // if (window.gtag) {
    //   console.log("GTAG is available.");
    //   window.gtag('get', 'G-XFV6SM08Y0', 'client_id', (client_id) => {
    //     dispatch('SET', {
    //       gaClientId: client_id,
    //     });
    //   });
    //   window.gtag('get', 'G-XFV6SM08Y0', 'session_id', (session_id) => {
    //     dispatch('SET', {
    //       gaSessionId: session_id,
    //     });
    //   });
    // } else {
    //   if (count < 5) {
    //     setTimeout(() => {
    //       getGAvalues(count + 1);
    //     }, 300);
    //   }
    // }
  }

  // useEffect(() => {
  //   if (hash) {
  //     // console.log('has hash');
  //     dispatch('SET', {
  //       section: hash
  //     });
  //     // const s = dateTimeConfirmed ? 2 : 1;
  //     // goDirect(s);
  //   }
  //   window.addEventListener('hashchange', changeHash, false);
  //   return () => window.removeEventListener('hashchange', changeHash, false);
  // }, []);

  useEffect(() => {
    if (appData) {
      for (let [key, value] of Object.entries(appData.ticket_types)) {
        setTours((tours) => [...tours, value]);
      }
      // console.log(appData.default_ticket_type.post_name);
      dispatch('SET', {
        section: appData.default_ticket_type.post_name
      });
    }
  }, [appData]);

  // const changeHash = () => {
  //   const h = window.location.hash.replace(/^#\/?|\/$/g, '').split('/');
  //   setHash(h);
  // }

  return (
    <>
      {appData && <Hero />}

      {!!(appData && !appData.maintenance_mode && step === 0) && <TicketsIntro />}

      {!!(appData && !appData.maintenance_mode) && <Container fluid="xl" className="mb-5">
        <Row className="card-container flex-nowrap flex-sm-wrap justify-content-start justify-content-sm-center">
          {tours.length > 0 && tours.map((t, i) => <Col key={i} xs={col.xs} sm={col.sm} md={col.md} lg={col.lg} className="pb-4"><PriceCard tour={t} /></Col>)}
        </Row>
      </Container>}

      {appData && !appData.disable_ticketing && step > 0 && <BookTickets />}

      {appData?.maintenance_mode && <Maintenance />}

      {appData && !appData.disable_ticketing && <Modal
        id="monthModal"
        size="small"
        closeButton={true}
        customCloseText="Cancel"
      >
        <Suspense fallback={<LoadingAnim />}>
          <Calendar endMonth={appData.end_date.end_month} endYear={appData.end_date.end_year} />
        </Suspense>
      </Modal>}
    </>
  );
}

function colSize(items) {
  switch (true) {
    case items.length >= 5:
      return { xs: 10, sm: 6, md: 6, lg: 4 }
      break;
    case items.length >= 3 && items.length <= 4:
      return { xs: 10, sm: 6, md: 6, lg: 3 }
      break;
    case items.length === 2:
      return { xs: 10, sm: 6, md: 6, lg: 6 }
      break;
    case items.length === 1:
      return { xs: 10, sm: 12, md: 12, lg: 12 }
      break;
  }
}

export default Ticketing;